// removed by extract-text-webpack-plugin
module.exports = {"this":"Aiyq0slbjKi47Sx2tmW51"};


//////////////////
// WEBPACK FOOTER
// ./src/projects/fengjr/App.scss
// module id = 383
// module chunks = 12